<div class="menu-section" [class.expand]="expand">
  <p *ngIf="title">{{ title }}</p>
  <div class="section-content">
    <ng-content></ng-content>
  </div>
  <hr *ngIf="separator" [class.partialSeparator]="separatorIsPartial">
</div>
